import { render } from "./FinanceIcon.vue?vue&type=template&id=016b6446&scoped=true"
const script = {}

import "./FinanceIcon.vue?vue&type=style&index=0&id=016b6446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016b6446"]])

export default __exports__